import React, { useState } from 'react';
import { Plus, Save, X } from 'lucide-react';
import { Badge } from '../ui/Badge';
import { Button } from '../ui/Button';
import { DatePicker } from '../ui/DatePicker';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
interface NewVisit {
  id: number;
  type: string;
  date: string;
  outcome: string;
  expiry: string;
  validityYears?: string;
}
export function WorkerHealthTab() {
  const [newVisits, setNewVisits] = useState<NewVisit[]>([]);
  const updateVisit = (idx: number, changes: Partial<NewVisit>) => {
    const updated = [...newVisits];
    updated[idx] = {
      ...updated[idx],
      ...changes
    };
    setNewVisits(updated);
  };
  return <div className="space-y-4" data-id="element-2007" data-mp="1i27lqbmiuap">
      <div className="flex justify-between items-center sticky top-0 bg-white z-10 py-1 pr-1" data-id="element-2008" data-mp="1h0k2mdf8fc3">
        <h4 className="font-bold text-seform-navy" data-id="element-2009" data-mp="p7ec4cw0ae6o">Visite mediche</h4>
        <Button size="sm" startContent={<Plus className="h-4 w-4" data-id="element-2011" data-mp="tzxs1gi61len" />} onClick={() => setNewVisits([...newVisits, {
        id: Date.now(),
        type: '',
        date: '',
        outcome: '',
        expiry: ''
      }])} data-id="element-2010" data-mp="tyd07yn8kgkh">
          Aggiungi visita
        </Button>
      </div>
      <div className="border border-slate-100 rounded-xl overflow-hidden" data-id="element-2012" data-mp="2ej5km67g0z42">
        <table className="w-full text-sm text-left" data-id="element-2013" data-mp="29qubccqtc0yu">
          <thead className="bg-slate-50 text-slate-500 font-semibold" data-id="element-2014" data-mp="29pavgn92jrxl">
            <tr data-id="element-2015" data-mp="2nhh9o3snvoue">
              <th className="p-3" data-id="element-2016" data-mp="2ngxtarint8ih">Tipo visita</th>
              <th className="p-3" data-id="element-2017" data-mp="2ik7es8mi6kz6">Data</th>
              <th className="p-3" data-id="element-2018" data-mp="2ij64i6dba2ii">Esito</th>
              <th className="p-3" data-id="element-2019" data-mp="2xgooywiyhtk5">Anni validità</th>
              <th className="p-3" data-id="element-2020" data-mp="2xggch5qqwq9h">Scadenza</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-2021" data-mp="2siwy85u1sdhj">
            <tr data-id="element-2022" data-mp="132xiu6zu5rtg">
              <td className="p-3" data-id="element-2023" data-mp="132fe0lz3y59x">Periodica</td>
              <td className="p-3" data-id="element-2024" data-mp="1337adz0j4719">10/01/2024</td>
              <td className="p-3" data-id="element-2025" data-mp="y4dtrxpy3zwv">
                <Badge variant="success" size="sm" data-id="element-2026" data-mp="y5f605ip6sg6">
                  Idoneo
                </Badge>
              </td>
              <td className="p-3" data-id="element-2027" data-mp="1nu2qqp5h7xe0">2</td>
              <td className="p-3" data-id="element-2028" data-mp="1rt1rryo37a06">10/01/2026</td>
            </tr>
            {newVisits.map((visit, idx) => <tr key={`new-visit-${visit.id}`} className="bg-orange-50/30" data-id="element-2029" data-mp="1wseorc8o9xgh" data-mpi={idx}>
                <td className="p-2" data-id="element-2030" data-mp="21rhlm9ei0xdd">
                  <Select value={visit.type} onChange={e => updateVisit(idx, {
                type: e.target.value
              })} options={[{
                value: '',
                label: 'Seleziona...'
              }, {
                value: 'Preventiva',
                label: 'Preventiva'
              }, {
                value: 'Periodica',
                label: 'Periodica'
              }, {
                value: 'Straordinaria',
                label: 'Straordinaria'
              }, {
                value: 'Preassuntiva',
                label: 'Preassuntiva'
              }, {
                value: 'Cambio mansione',
                label: 'Cambio mansione'
              }]} data-id="element-2031" data-mp="21skaycw6arr6" />
                </td>
                <td className="p-2" data-id="element-2032" data-mp="istf9cdsa6t7">
                  <DatePicker value={visit.date} onChange={e => updateVisit(idx, {
                date: e.target.value
              })} data-id="element-2033" data-mp="ituqphypovbg" />
                </td>
                <td className="p-2" data-id="element-2034" data-mp="8vyh4ulfa8fg">
                  <Select value={visit.outcome} onChange={e => updateVisit(idx, {
                outcome: e.target.value
              })} options={[{
                value: '',
                label: 'Seleziona...'
              }, {
                value: 'Idoneo',
                label: 'Idoneo'
              }, {
                value: 'Parzialmente idoneo',
                label: 'Parzialmente idoneo'
              }, {
                value: 'Non idoneo',
                label: 'Non idoneo'
              }]} data-id="element-2035" data-mp="8wztd2e6d0yr" />
                </td>
                <td className="p-2" data-id="element-2036" data-mp="1fjluy8wt1wug">
                  <Input type="number" placeholder="2" value={visit.validityYears || ''} onChange={e => updateVisit(idx, {
                validityYears: e.target.value
              })} data-id="element-2037" data-mp="1fika5cpzlvzj" />
                </td>
                <td className="p-2" data-id="element-2038" data-mp="q4zdrp2zihsm">
                  <div className="flex gap-1 items-center" data-id="element-2039" data-mp="v1zj1xs0fgio">
                    <DatePicker value={visit.expiry} onChange={e => updateVisit(idx, {
                  expiry: e.target.value
                })} data-id="element-2040" data-mp="v2hnhhott11o" />
                    <Button size="sm" variant="flat" color="success" className="!px-2 flex-shrink-0" onClick={() => {}} data-id="element-2041" data-mp="1920ozrn4te50">
                      <Save className="h-3.5 w-3.5" data-id="element-2042" data-mp="21p4wc39p64jy" />
                    </Button>
                    <Button size="sm" variant="flat" color="danger" className="!px-2 flex-shrink-0" onClick={() => setNewVisits(newVisits.filter((_, i) => i !== idx))} data-id="element-2043" data-mp="26ig3k5if8nce">
                      <X className="h-3.5 w-3.5" data-id="element-2044" data-mp="4u1snto55wn4" />
                    </Button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}